export default {
  templates: 'Compliance templates',
  buttons: {
    upload: 'Upload compliance document',
    templates: 'View compliance templates',
    uploadDoc: 'Upload document',
    download: 'Download',
    downloadAll: 'Download all',
    deleteDoc: 'Delete document',
  },
  templatesDialog: {
    title: 'Compliance templates',
    body: 'Budget Control by BOQNET has stored standard document templates which most banks require. Download the document you need below, complete it, and re-upload to your site compliance storage.',
    search: 'Search templates by name',
    noSearchResults: 'No templates found matching "{searchTerm}"',
    emptyStateMessage: 'No compliance templates ready yet',
    close: 'Close',
    download: 'Download',
  },
  uploadDocumentDialog: {
    title: 'Upload document',
    body: 'Drag and drop, or click the ‘Upload file’ area below to select your file for upload.',
    field: 'Upload a file',
  },
  deleteDocDialog: {
    title: 'Delete document',
    body: 'Are you sure you want to delete this document?',
  },
  toast: {
    uploadSuccess: {
      title: 'Document uploaded',
      content: 'Document has been successfully uploaded',
    },
    uploadFailure: {
      title: 'Upload failed',
      content: 'File failed to upload. Please try again',
    },
    uploadValidation: {
      validationMessage: 'Max file size: 10MB. Max filename length: 200 chars.',
      maxFileSize: 'File size cannot exceed {maxSize}MB. This file is {fileSize}MB.',
      maxFileNameLength:
        'Filename cannot exceed {maxLength} characters. This file is {fileLength} characters.',
      duplicateFileName: 'A file with this name already exists for this draw',
      genericError: 'This file is invalid',
    },
    deleteSuccess: {
      title: 'Document successfully removed',
      content: 'Document has been successfully removed',
    },
    deleteFailure: {
      title: 'Document removal failed',
      content: 'Failed to remove document. Please try again',
    },
    downloadFailure: {
      title: 'Download failed',
      content: 'Failed to download document. Please try again',
    },
  },
  table: {
    headers: {
      name: 'Document name',
      createdAt: 'Uploaded',
      actions: 'Actions',
    },
  },
};
